'use client';

import { useSearchParams } from 'next/navigation';

import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';

import { EntryPopupPageSetter } from '../shared/entry-popup';
import { LeaderboardContext } from './bunja';
import { Header } from './header';
import { MyInfoSection } from './my-info/section';
import { RankList } from './rank-list';
import { ScrollToTopButton } from './scroll-to-top-button';
import { SegmentView } from './segment-view';
import { tradingLeaderboardIntervals, tradingLeaderboardTiers } from './shared/constants';
import { IntervalTabs } from './tabs/interval-tabs';
import { TierTabs } from './tabs/tier-tabs';
import { TierDescription } from './tier-description';

export const TradingLeaderboardPage = () => {
  const leaderboardContextValue = useLeaderboardContextFromSearchParams();

  return (
    <>
      <main
        className={css({
          tablet: { minH: 'minHeightWithoutNavigation', maxW: 'desktopMaxWidth', px: 16, pb: 16, mx: 'auto', mb: 150 },
        })}
      >
        <Header css={{ tablet: { pt: 80, pb: 40 }, tabletDown: { pt: 24, pb: 16 } }} />
        <LeaderboardContext value={leaderboardContextValue}>
          <SegmentView />
          <IntervalTabs />
          <TierTabs css={{ tabletDown: { p: 12 }, tablet: { py: 16 } }} />
          <div className={stack({ tabletDown: { flexDirection: 'column-reverse' } })}>
            <TierDescription css={{ tabletDown: { px: 16 } }} />
            <MyInfoSection css={{ tablet: { mt: 24 } }} />
          </div>
          <RankList css={{ mt: { base: 12, tablet: 24 } }} />
        </LeaderboardContext>
        <ScrollToTopButton />
      </main>
      <EntryPopupPageSetter page='TRADING_LEADERBOARD' />
    </>
  );
};

function useLeaderboardContextFromSearchParams(): LeaderboardContext {
  const searchParams = useSearchParams();
  const tier = searchParams.get('tier') ?? 'NORMAL';
  const interval = searchParams.get('interval') ?? 'WEEKLY';
  return {
    tier: tradingLeaderboardTiers.includes(tier) ? tier : 'ALL',
    interval: tradingLeaderboardIntervals.includes(interval) ? interval : 'WEEKLY',
  } as LeaderboardContext;
}
